<template>
    <div class="index-wrap" style="background: none">
      <div class="index-menu menuBg">
        <div class="header-main">
          <div class="menu">
            <a class="logo" href="javascript:;">
              <img src="../../public/assets/img/logo.png">
            </a>
            <div class="menu_left">
              <router-link to="/" exact active-class="active" class="anchor-link">首页</router-link>
              <router-link :to="{ name: 'ServiceList' }" class="anchor-link">服务列表</router-link>
              <router-link :to="{ name: 'PayMent' }" class="anchor-link">付费方式</router-link>
              <router-link :to="{ name: 'IntroduceAbout' }" class="anchor-link">关于我们</router-link>
            </div>
            <div class="phone">
              19567978183
            </div>
            <div class="info">
              <!-- {{ user }} -->
              <div v-if="user">
                <a href="https://vip.zhaobiaoguancha.cn/user/index" style="color:white">会员中心</a>
                <div class="user-info" style="display:none">
                  <div class="header-usermenu">
                    <a href="javascript:;" class="header-title show_nickname">{{ user.username }}</a>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="loginReg">
                  <a class="reg" href="https://vip.zhaobiaoguancha.cn/user/login?tab=register">注册</a>
                  <a class="login" href="https://vip.zhaobiaoguancha.cn/user/login?tab=login">登录</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="service-wrap">
        <table cellspacing="0" cellpadding="0">
          <tr>
            <th colspan="4">中国招标采购网会员服务列表</th>
          </tr>
          <tr>
            <td>会员价格<br />(包含以下所有服务)</td>
            <td colspan="3">（地区会员 3800 元/年）<br />（全国会员 5800 元/年）</td>
          </tr>
          <tr>
            <td>招标预告</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>商机订阅</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>招标公告</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>邮件发送</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>变更公告</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>招标代理咨询</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>中标结果</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>电话通知</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>电子比选公告</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>企业认证服务</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>意见征集公告</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>产品在线销售</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>反拍公告</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>拥有公司主页</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>竞争性谈判公告</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>拥有VIP标识</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>会员采购</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>信息优先排序</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>企业采购</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>信息关键字排名</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>邀请招标</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>自定义公司主页</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>拟建项目信息</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>自定义公司模板</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>审批项目</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>采购网资讯</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>规划项目</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>二对一人工客服</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr>
            <td>环评项目</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
            <td>招标文件下载</td>
            <td><img src="../../public/assets/static/img/right.png"></td>
          </tr>
          <tr class="imgCon">
            <td>业主委托项目</td>
            <td>业主委托项目推荐成功后，抽取供应商中标价格（成交价格）的0.2%-2%的服务费<img src="../../public/assets/static/img/right.png"></td>
            <td>代购标书</td>
            <td>另行收费</td>
          </tr>
          <tr class="imgCon">
            <td>VIP独家项目</td>
            <td>VIP独家项目推荐成功后，抽取供应商中标价格（成交价格）的0.2%-2%的服务费<img src="../../public/assets/static/img/right.png"></td>
            <td>代写标书</td>
            <td>另行收费</td>
          </tr>

        </table>
      </div>
      <div class="footer">
        <p class="copyright">
          © 2017-2025 招标采购网 All Rights Reserved. Power By 京源
        </p>
      </div>
    </div>
</template>

<script>
// import Header from "@/components/HeaderInfo.vue";
// import FooterInfo from "@/components/FooterInfo.vue";

export default {
  // components: {
  //   Header,
  //   FooterInfo,
  // },
  data() {
    return {
      user: null, // 用户信息，需通过 API 获取
    };
  },
  created() {
    // 示例：模拟用户数据，实际应通过接口请求用户信息
    this.user = {
      nickname: "测试用户",
    };
  },
};
</script>

<style scoped>
/* 可导入原有的 CSS 文件 */
/* @import "/static/css/reset.css";
  @import "/static/css/index.css";
  @import "/static/css/common.css";
   */
/* 其他本地样式可在此定义 */
</style>